import Body from "../../../../../../material/skeleton/Body";
import useRequestedDocumentRepository from "../../../../../../repository/emergency/useRequestedDocumentRepository";
import {useEffect, useState} from "react";
import isNull from "../../../../../../mixin/isNull";
import LoadingData from "../common/LoadingData";
import RequestedDocument from "../../../../../../entity/emergency/RequestedDocument";
import {Alert, Button, Chip, CircularProgress, Slide} from "@mui/material";
import Box from "@mui/material/Box";
import ClientInvoiceDetails from "../common/ClientInvoiceDetails";
import UploadRequestedDocument from "./UploadRequestedDocument";
import DeliveryCertificateEntrypoint from "./delivery-certificate/DeliveryCertificateEntrypoint";
import useInterventionRepository from "../../../../../../repository/emergency/useInterventionRepository";
import useHelper from "../../../../../../use/useHelper";
import Typography from "@mui/material/Typography";
import Footer from "../../../../../../material/skeleton/Footer";
import {ArrowBack} from "@mui/icons-material";
import {useNavigate} from "react-router";
import route from "../../../../../../enum/route";
import useSecurity from "../../../../../../use/useSecurity";
import useQuotationRepository from "../../../../../../repository/emergency/useQuotationRepository";

export default function ({qualityInspectionId, clientId, interventionId, orderId}) {
    const navigate = useNavigate();
    const security = useSecurity();
    const helper = useHelper();
    const requestedDocumentRepository = useRequestedDocumentRepository();
    const interventionRepository = useInterventionRepository();
    const quotationRepository = useQuotationRepository();
    /** @type RequestedDocument[] */
    const requestedDocuments = requestedDocumentRepository.findAllByInterventionId(interventionId).select();
    /** @type Intervention */
    const intervention = interventionRepository.findOneById(interventionId).select();
    /** @type Quotation */
    const quotation = quotationRepository.findOneById(intervention?.getQuotationId()).select();
    const [skipSignature, setSkipSignature] = useState(false);

    useEffect(() => {
        requestedDocumentRepository.findAllByInterventionId(interventionId).exec();
        interventionRepository.findOneById(interventionId).exec();
    }, []);

    useEffect(() => {
        if (isNull(intervention)) return;

        quotationRepository.findOneById(intervention.getQuotationId()).exec();
    }, [JSON.stringify(intervention)]);


    const isDeliveryCertificateRequested = () => {
        return !isNull(requestedDocuments.find(
            rd =>
                rd.getName() === RequestedDocument.DELIVERY_CERTIFICATE_NAME
                && rd.getStatus() === RequestedDocument.STATUS_REQUESTED
        ));
    }

    const isClientPriceRequested = () => {
        return !isNull(requestedDocuments.find(
            rd =>
                rd.getName() === RequestedDocument.CLIENT_PRICE_INVOICE_NAME
                && rd.getStatus() === RequestedDocument.STATUS_REQUESTED
        ));
    }

    const handleBack = () => {
        navigate(route.ENTREPRENEUR_INTERVENTIONS);
    }

    if (isNull(requestedDocuments) || isNull(intervention) || isNull(quotation)) return <LoadingData/>;

    return (
        <>
            <Body hasFooter={isDeliveryCertificateRequested() && !skipSignature}>
                {
                    !isDeliveryCertificateRequested()
                    || skipSignature
                        ? (
                            <Slide in={true} direction={"right"} timeout={500}>
                                <Box px={1} mt={2}>
                                    {
                                        isClientPriceRequested()
                                            ? (
                                                <>
                                                    <Alert severity={"info"} data-test="client-billing">
                                                        Facturez le sociétaire à hauteur
                                                        de {helper.priceFormatter(intervention.getClientPrice())} €
                                                        HT, {helper.priceFormatter(intervention.getClientPrice() * ((quotation.getVat() / 100) + 1))} €
                                                        TTC
                                                    </Alert>

                                                    <Box mt={2}>
                                                        <ClientInvoiceDetails
                                                            interventionId={interventionId}
                                                            title={"Merci de faire apparaitre sur la facture destinée au sociétaire :"}
                                                        />
                                                    </Box>

                                                    {
                                                        requestedDocuments.filter(rd => rd.getStatus() === RequestedDocument.STATUS_REQUESTED).map(rd => (
                                                            <Box key={rd.getId()} mt={5}>
                                                                <UploadRequestedDocument
                                                                    requestedDocumentId={rd.getId()}/>
                                                            </Box>
                                                        ))
                                                    }
                                                </>
                                            )
                                            : (
                                                <>
                                                    {
                                                        requestedDocuments.filter(rd => rd.getStatus() === RequestedDocument.STATUS_REQUESTED).map(rd => (
                                                            <Box key={rd.getId()} mt={5}>
                                                                <UploadRequestedDocument requestedDocumentId={rd.getId()}/>
                                                            </Box>
                                                        ))
                                                    }

                                                    <Box mt={10}>
                                                        <Alert severity={"info"} data-test="company-billing">
                                                            Facturez FAIRFAIR à hauteur
                                                            de {helper.priceFormatter(intervention.getArtisanPrice() * (isNull(quotation.getVat()) ? 1 : 1.1))} €
                                                            TTC
                                                        </Alert>
                                                    </Box>

                                                    <Box mt={15} display="flex" justifyContent="center">
                                                        <Chip
                                                            label={"L'application est terminée"}
                                                            color={"success"}
                                                            size="large"
                                                        />
                                                    </Box>
                                                    <Box mt={2}>
                                                        <Button
                                                            startIcon={<ArrowBack/>}
                                                            variant="contained"
                                                            fullWidth
                                                            onClick={handleBack}
                                                        >
                                                            Retourner aux interventions
                                                        </Button>
                                                    </Box>
                                                </>
                                            )
                                    }
                                </Box>
                            </Slide>
                        )
                        : <DeliveryCertificateEntrypoint onSkip={() => setSkipSignature(true)}/>
                }

            </Body>
            {
                isDeliveryCertificateRequested() && !skipSignature
                    ? (
                        <Footer>
                            <Button
                                sx={{height: 50, borderRadius: 0}}
                                variant="contained"
                                fullWidth
                                size={"large"}
                                disabled={true}
                            >
                                <CircularProgress size={20} color={"inherit"}/>
                                <Typography display="inline">
                                    &nbsp;Attente de signature
                                </Typography>
                            </Button>
                        </Footer>
                    )
                    : null
            }
        </>
    )
}